package ai.flowstorm.studio.ui.builder

import ai.flowstorm.common.ui.JsonEditor
import ai.flowstorm.studio.ui.design.dialogue.panel.LogPanel
import io.kvision.core.onEvent
import io.kvision.i18n.I18n.tr
import io.kvision.modal.Modal
import io.kvision.modal.ModalSize
import io.kvision.panel.tab
import io.kvision.panel.tabPanel

class BuildResultModal(allowOpenAsNew: Boolean = false) :
    Modal(tr("Build Result"), size = ModalSize.LARGE, scrollable = true) {


    val jsonEditor = JsonEditor(BuildItem.serializer())
    val logPanel = LogPanel()

    init {
        closeIcon.onEvent {
            click = { cancel() }
        }

        tabPanel {
            tab("Build log") {
                add(logPanel)
            }
            tab("JSON") {
                add(jsonEditor)
            }
        }
    }

    fun open(result: BuildItem) {

        jsonEditor.setData(result)
        logPanel.apply {
            clearLog()
            log(result.result?.logs ?: listOf())
        }


        show()
    }

    fun cancel() {
        hide()
    }
}
